import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';

const ProviderApp = () => {
    const navigate = useNavigate()
    useEffect(() => {
        navigate('/provider-app/download')
    }, []);

    return (<></>)
}

export default ProviderApp

